import { useEffect, useState } from "react";
import { DatabaseTab } from "./DatabaseTab";

type DevTab = "database";

/** Owner-only full-screen dev console; tabs grow as tools are added. */
export function DevToolsDialog({ onClose }: { onClose: () => void }) {
  const [tab, setTab] = useState<DevTab>("database");
  const tabs: { id: DevTab; label: string }[] = [{ id: "database", label: "Database" }];

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/30 p-3"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="flex h-full w-full flex-col rounded-lg border border-stroke bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-stroke px-4 py-3">
          <h2 className="text-[15px] font-semibold">Dev tools</h2>
          <button
            onClick={onClose}
            aria-label="Close dev tools"
            className="rounded px-2 text-[16px] text-ink-muted hover:bg-black/5"
          >
            ×
          </button>
        </div>

        <div className="flex items-stretch gap-1 border-b border-stroke px-3">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`relative px-3 py-2 text-[13px] ${
                tab === t.id ? "font-semibold text-accent" : "text-ink-muted hover:text-ink"
              }`}
            >
              {t.label}
              {tab === t.id && (
                <span className="absolute inset-x-2 bottom-0 h-[2px] rounded-t bg-accent" />
              )}
            </button>
          ))}
        </div>

        <div className="min-h-0 flex-1 overflow-hidden">
          {tab === "database" && <DatabaseTab />}
        </div>
      </div>
    </div>
  );
}
